// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/websocketnotify/v1/websocketnotify.proto" (package "c1.api.websocketnotify.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { MessageType } from "@protobuf-ts/runtime";
import { Any } from "../../../../google/protobuf/any";
import { Timestamp } from "../../../../google/protobuf/timestamp";
/**
 * @generated from protobuf message c1.api.websocketnotify.v1.ChangedRef
 */
export interface ChangedRef {
    /**
     * @generated from protobuf field: c1.api.websocketnotify.v1.ChangedRefEventType event_type = 1;
     */
    eventType: ChangedRefEventType;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp last_updated_at = 2;
     */
    lastUpdatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Any changed = 3;
     */
    changed?: Any;
}
/**
 * AuthMessage - proto-based, extensible for future auth mechanisms (e.g., DPoP)
 *
 * @generated from protobuf message c1.api.websocketnotify.v1.AuthMessage
 */
export interface AuthMessage {
    /**
     * @generated from protobuf field: string access_token = 1;
     */
    accessToken: string; // Reserved for future: DPoP proof, nonces, etc.
}
/**
 * @generated from protobuf message c1.api.websocketnotify.v1.RefSubscription
 */
export interface RefSubscription {
    /**
     * @generated from protobuf field: string ref_type = 1;
     */
    refType: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any refs = 2;
     */
    refs: Any[];
    /**
     * @generated from protobuf field: bool watch_inserts = 3;
     */
    watchInserts: boolean;
}
/**
 * @generated from protobuf message c1.api.websocketnotify.v1.SubscribeMessage
 */
export interface SubscribeMessage {
    /**
     * @generated from protobuf field: string access_token = 1;
     */
    accessToken: string;
    /**
     * @generated from protobuf field: repeated c1.api.websocketnotify.v1.RefSubscription ref_subscriptions = 2;
     */
    refSubscriptions: RefSubscription[];
}
/**
 * JoinConversationMessage - Client requests to receive messages for a conversation
 *
 * @generated from protobuf message c1.api.websocketnotify.v1.JoinConversationMessage
 */
export interface JoinConversationMessage {
    /**
     * @generated from protobuf field: string access_token = 1;
     */
    accessToken: string;
    /**
     * @generated from protobuf field: string conversation_id = 2;
     */
    conversationId: string;
}
/**
 * LeaveConversationMessage - Client stops receiving messages for a conversation
 *
 * @generated from protobuf message c1.api.websocketnotify.v1.LeaveConversationMessage
 */
export interface LeaveConversationMessage {
    /**
     * @generated from protobuf field: string conversation_id = 1;
     */
    conversationId: string;
}
/**
 * ChatMessage - Server sends chat message to client
 *
 * @generated from protobuf message c1.api.websocketnotify.v1.ChatMessage
 */
export interface ChatMessage {
    /**
     * @generated from protobuf field: string conversation_id = 1;
     */
    conversationId: string;
    /**
     * @generated from protobuf field: bytes payload = 2;
     */
    payload: Uint8Array; // Binary-encoded UIMessage from c1.api.conversations.v1
}
/**
 * AuthAck - Server confirms successful authentication
 *
 * @generated from protobuf message c1.api.websocketnotify.v1.AuthAck
 */
export interface AuthAck {
}
/**
 * ErrorMessage - Server reports errors
 *
 * @generated from protobuf message c1.api.websocketnotify.v1.ErrorMessage
 */
export interface ErrorMessage {
    /**
     * @generated from protobuf field: string code = 1;
     */
    code: string;
    /**
     * @generated from protobuf field: string message = 2;
     */
    message: string;
}
/**
 * ClientMessage - Client-to-server envelope with all operations
 *
 * @generated from protobuf message c1.api.websocketnotify.v1.ClientMessage
 */
export interface ClientMessage {
    /**
     * @generated from protobuf oneof: message
     */
    message: {
        oneofKind: "auth";
        /**
         * @generated from protobuf field: c1.api.websocketnotify.v1.AuthMessage auth = 1;
         */
        auth: AuthMessage;
    } | {
        oneofKind: "subscribe";
        /**
         * @generated from protobuf field: c1.api.websocketnotify.v1.SubscribeMessage subscribe = 2;
         */
        subscribe: SubscribeMessage;
    } | {
        oneofKind: "joinConversation";
        /**
         * @generated from protobuf field: c1.api.websocketnotify.v1.JoinConversationMessage join_conversation = 3;
         */
        joinConversation: JoinConversationMessage;
    } | {
        oneofKind: "leaveConversation";
        /**
         * @generated from protobuf field: c1.api.websocketnotify.v1.LeaveConversationMessage leave_conversation = 4;
         */
        leaveConversation: LeaveConversationMessage;
    } | {
        oneofKind: undefined;
    };
}
/**
 * ServerMessage - Typed server-to-client envelope for all responses
 *
 * @generated from protobuf message c1.api.websocketnotify.v1.ServerMessage
 */
export interface ServerMessage {
    /**
     * @generated from protobuf oneof: message
     */
    message: {
        oneofKind: "changedRef";
        /**
         * @generated from protobuf field: c1.api.websocketnotify.v1.ChangedRef changed_ref = 1;
         */
        changedRef: ChangedRef;
    } | {
        oneofKind: "chatMessage";
        /**
         * @generated from protobuf field: c1.api.websocketnotify.v1.ChatMessage chat_message = 2;
         */
        chatMessage: ChatMessage;
    } | {
        oneofKind: "authAck";
        /**
         * @generated from protobuf field: c1.api.websocketnotify.v1.AuthAck auth_ack = 3;
         */
        authAck: AuthAck;
    } | {
        oneofKind: "error";
        /**
         * @generated from protobuf field: c1.api.websocketnotify.v1.ErrorMessage error = 4;
         */
        error: ErrorMessage;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf enum c1.api.websocketnotify.v1.ChangedRefEventType
 */
export enum ChangedRefEventType {
    /**
     * @generated from protobuf enum value: CHANGED_REF_EVENT_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: CHANGED_REF_EVENT_TYPE_INSERT = 1;
     */
    INSERT = 1,
    /**
     * @generated from protobuf enum value: CHANGED_REF_EVENT_TYPE_MODIFY = 2;
     */
    MODIFY = 2,
    /**
     * @generated from protobuf enum value: CHANGED_REF_EVENT_TYPE_REMOVE = 3;
     */
    REMOVE = 3
}
// @generated message type with reflection information, may provide speed optimized methods
class ChangedRef$Type extends MessageType<ChangedRef> {
    constructor() {
        super("c1.api.websocketnotify.v1.ChangedRef", [
            { no: 1, name: "event_type", kind: "enum", T: () => ["c1.api.websocketnotify.v1.ChangedRefEventType", ChangedRefEventType, "CHANGED_REF_EVENT_TYPE_"] },
            { no: 2, name: "last_updated_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "changed", kind: "message", T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.websocketnotify.v1.ChangedRef
 */
export const ChangedRef = new ChangedRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AuthMessage$Type extends MessageType<AuthMessage> {
    constructor() {
        super("c1.api.websocketnotify.v1.AuthMessage", [
            { no: 1, name: "access_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.websocketnotify.v1.AuthMessage
 */
export const AuthMessage = new AuthMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RefSubscription$Type extends MessageType<RefSubscription> {
    constructor() {
        super("c1.api.websocketnotify.v1.RefSubscription", [
            { no: 1, name: "ref_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "watch_inserts", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.websocketnotify.v1.RefSubscription
 */
export const RefSubscription = new RefSubscription$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SubscribeMessage$Type extends MessageType<SubscribeMessage> {
    constructor() {
        super("c1.api.websocketnotify.v1.SubscribeMessage", [
            { no: 1, name: "access_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ref_subscriptions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RefSubscription }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.websocketnotify.v1.SubscribeMessage
 */
export const SubscribeMessage = new SubscribeMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class JoinConversationMessage$Type extends MessageType<JoinConversationMessage> {
    constructor() {
        super("c1.api.websocketnotify.v1.JoinConversationMessage", [
            { no: 1, name: "access_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "conversation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.websocketnotify.v1.JoinConversationMessage
 */
export const JoinConversationMessage = new JoinConversationMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LeaveConversationMessage$Type extends MessageType<LeaveConversationMessage> {
    constructor() {
        super("c1.api.websocketnotify.v1.LeaveConversationMessage", [
            { no: 1, name: "conversation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.websocketnotify.v1.LeaveConversationMessage
 */
export const LeaveConversationMessage = new LeaveConversationMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ChatMessage$Type extends MessageType<ChatMessage> {
    constructor() {
        super("c1.api.websocketnotify.v1.ChatMessage", [
            { no: 1, name: "conversation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "payload", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.websocketnotify.v1.ChatMessage
 */
export const ChatMessage = new ChatMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AuthAck$Type extends MessageType<AuthAck> {
    constructor() {
        super("c1.api.websocketnotify.v1.AuthAck", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.websocketnotify.v1.AuthAck
 */
export const AuthAck = new AuthAck$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ErrorMessage$Type extends MessageType<ErrorMessage> {
    constructor() {
        super("c1.api.websocketnotify.v1.ErrorMessage", [
            { no: 1, name: "code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.websocketnotify.v1.ErrorMessage
 */
export const ErrorMessage = new ErrorMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ClientMessage$Type extends MessageType<ClientMessage> {
    constructor() {
        super("c1.api.websocketnotify.v1.ClientMessage", [
            { no: 1, name: "auth", kind: "message", oneof: "message", T: () => AuthMessage },
            { no: 2, name: "subscribe", kind: "message", oneof: "message", T: () => SubscribeMessage },
            { no: 3, name: "join_conversation", kind: "message", oneof: "message", T: () => JoinConversationMessage },
            { no: 4, name: "leave_conversation", kind: "message", oneof: "message", T: () => LeaveConversationMessage }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.websocketnotify.v1.ClientMessage
 */
export const ClientMessage = new ClientMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ServerMessage$Type extends MessageType<ServerMessage> {
    constructor() {
        super("c1.api.websocketnotify.v1.ServerMessage", [
            { no: 1, name: "changed_ref", kind: "message", oneof: "message", T: () => ChangedRef },
            { no: 2, name: "chat_message", kind: "message", oneof: "message", T: () => ChatMessage },
            { no: 3, name: "auth_ack", kind: "message", oneof: "message", T: () => AuthAck },
            { no: 4, name: "error", kind: "message", oneof: "message", T: () => ErrorMessage }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.websocketnotify.v1.ServerMessage
 */
export const ServerMessage = new ServerMessage$Type();
